import { useRef, useEffect, useState } from "react";
import Pagination from "../../../../Components/Pagination";
import Button from "../../../../Core/Button/Button";

const Table = ({ TB_data=[] }) => {
  const tableRef = useRef();
  const [rowsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  
  // Calculate pagination values
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = TB_data.slice(indexOfFirstRow, indexOfLastRow);

  useEffect(() => {
    // Column resizing functionality
    const cols = tableRef.current.querySelectorAll("th");
    cols.forEach((col) => {
      const resizer = document.createElement("div");
      resizer.className = "resizer";
      col.appendChild(resizer);

      let x = 0;
      let w = 0;

      const onMouseDown = (e) => {
        x = e.clientX;
        w = col.offsetWidth;

        document.addEventListener("mousemove", onMouseMove);
        document.addEventListener("mouseup", onMouseUp);
      };

      const onMouseMove = (e) => {
        const dx = e.clientX - x;
        col.style.width = `${w + dx}px`;
      };

      const onMouseUp = () => {
        document.removeEventListener("mousemove", onMouseMove);
        document.removeEventListener("mouseup", onMouseUp);
      };

      resizer.addEventListener("mousedown", onMouseDown);
    });
  }, []);

  return (
    <div className="">
      <table className="table table-bordered mb-1" ref={tableRef}>
        <thead className="tableHead1">
          <tr>
            {["S.No", "Item Code", "Item Name", "Description", "Required Qty", 
              "Transferred Qty", "Consumed Qty", "Source Warehouse"].map((title, i) => {
              const defaultWidths = {
                "S.No": "6%",
                "Item Code": "110px",
                "Item Name": "220px",
                "Description": "220px",
                "Required Qty": "100px",
                "Transferred Qty": "120px",
                "Consumed Qty": "100px",
                "Source Warehouse": "11%",
              };

              return (
                <th
                  key={i}
                  style={{
                    fontSize: '7px',
                    position: "relative",
                    textAlign: title === "S.No" || title.includes("Qty") ? "center" : "left",
                    width: defaultWidths[title] || "150px",
                    minWidth: defaultWidths[title] || "150px",
                  }}
                >
                  {title}
                </th>
              );
            })}
          </tr>
        </thead>

        <tbody>
          {currentRows.map((row, index) => {
            const globalIndex = indexOfFirstRow + index;
            return (
              <tr key={row.name}>
                <td style={{
                  textAlign: "center",
                  fontSize: '0.8rem',
                  padding: '0.5rem'
                }}>
                  {globalIndex + 1}
                </td>
                <td className="p-0">
                  <input
                    type="text"
                    className="form-control tableinput noborder"
                    style={{ fontSize: '0.8rem' }}
                    readOnly
                    value={row.item_code}
                  />
                </td>
                <td className="p-0">
                  <input 
                    type="text" 
                    className="form-control tableinput noborder" 
                    style={{ fontSize: '0.8rem' }} 
                    readOnly 
                    value={row.item_name} 
                  />
                </td>
                <td className="p-0">
                  <input 
                    type="text" 
                    className="form-control tableinput noborder" 
                    style={{ fontSize: '0.8rem' }} 
                    readOnly 
                    value={row.description} 
                  />
                </td>
                <td className="p-0" style={{ textAlign: "center" }}>
                  <input 
                    type="text" 
                    className="form-control tableinput noborder" 
                    style={{ fontSize: '0.8rem' }} 
                    readOnly 
                    value={row.required_qty} 
                  />
                </td>
                <td className="p-0" style={{ textAlign: "center" }}>
                  <input 
                    type="text" 
                    className="form-control tableinput noborder" 
                    style={{ fontSize: '0.8rem' }} 
                    readOnly 
                    value={row.transferred_qty} 
                  />
                </td>
                <td className="p-0" style={{ textAlign: "center" }}>
                  <input 
                    type="text" 
                    className="form-control tableinput noborder" 
                    style={{ fontSize: '0.8rem' }} 
                    readOnly 
                    value={row.consumed_qty} 
                  />
                </td>
                <td className="p-0">
                  <input 
                    type="text" 
                    className="form-control tableinput noborder" 
                    style={{ fontSize: '0.8rem' }} 
                    readOnly 
                    value={row.source_warehouse} 
                  />
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      
      <div className="d-flex pb-2 justify-content-between align-items-center">
        <div className="d-flex" style={{ gap: '4px' }}>
         
        </div>

        <div className={`${TB_data.length < 11 ? "d-none" : "d-flex"} align-items-center centerpagination`} style={{ gap: '5px' }}>
          <Pagination
            setCurrentPage={setCurrentPage}
            currentPage={currentPage}
            pageSize={rowsPerPage}
            totalrecords={TB_data.length}
          />
        </div>

        <div className={`${TB_data.length < 11 ? "d-none" : "d-flex"}`}>
          <span className="px-2" style={{ fontSize: '12px', color: '#270B79' }}>
            Showing {indexOfFirstRow + 1} to {Math.min(indexOfLastRow, TB_data.length)} of {TB_data.length} entries
          </span>
        </div>
      </div>
    </div>
  );
};

export default Table;